import React from "react";
import {Card, Dropdown, Menu, Modal} from "antd";
import {MenuOutlined} from '@ant-design/icons';
import styled from 'styled-components';
import {Link} from "react-router-dom";
import {inject} from "mobx-react";

const StyledCard = styled(Card)`
  box-shadow: 0px 2px 4px rgba(141, 149, 166, 0.1);
  border-radius: 4px;

  .ant-card-head {
    border: none;
  }
  .ant-card-body {
    padding-top: 12px;
  }
`


const DashboardItemDropdown = inject('dashboard')(({ itemId, item, dashboard }) => {
  const removeDashboardItem = (id) =>
  {
      dashboard.removeItem(id);
      dashboard.postToServer();
  }

  const dashboardItemDropdownMenu = (
    <Menu>
      <Menu.Item>
        <Link to={`/explore/${dashboard.id}?itemId=${itemId}`}>Изменить</Link>
      </Menu.Item>
      <Menu.Item
        onClick={() =>
          Modal.confirm({
            title: "Вы уверены что хотите удалить компонент?",
            okText: "Да",
            okType: "danger",
            cancelText: "Нет",

            onOk() {
              removeDashboardItem( itemId);
            }
          })
        }
      >
        Удалить
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown
      overlay={dashboardItemDropdownMenu}
      placement="bottomLeft"
      trigger={["click"]}
    >
        <MenuOutlined />
    </Dropdown>
  );
});

const DashboardItem = ({ itemId, children, title, item }) => (
  <StyledCard
    title={title}
    bordered={false}
    style={{
      height: "100%",
      width: "100%"
    }}
    extra={<DashboardItemDropdown itemId={itemId} item={item} />}
  >
    {children}
  </StyledCard>
);

export default DashboardItem;
